import React from 'react';
import { MailIcon, BookOpenIcon, MessageSquareIcon } from 'lucide-react';
import { ContactForm } from './ContactForm';
export function ContactSection() {
  return <section id="contact" data-component="COMP-09-ContactSection" className="py-24 bg-white" data-id="element-115">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-116">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-117">
          {/* Left Side: Copy & Info */}
          <div data-id="element-118">
            <span className="block text-sm font-bold tracking-widest uppercase mb-3 text-gold-700" data-id="element-119">
              Get In Touch
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-navy-900 mb-6" data-id="element-120">
              Ready to join the team?
            </h2>
            <p className="text-lg text-navy-600 mb-10" data-id="element-121">
              Whether you're a parent looking to book a session, a school
              interested in our programmes, or a coach wanting to join our
              ranks, we'd love to hear from you.
            </p>

            <div className="space-y-6" data-id="element-122">
              <div className="flex items-start" data-id="element-123">
                <div className="w-12 h-12 rounded-full bg-navy-50 flex items-center justify-center text-brand-blue mr-4 flex-shrink-0" data-id="element-124">
                  <MailIcon className="w-6 h-6" data-id="element-125" />
                </div>
                <div data-id="element-126">
                  <h4 className="font-bold text-navy-900 text-lg" data-id="element-127">
                    General Enquiries
                  </h4>
                  <p className="text-navy-600" data-id="element-128">
                    Questions about bookings or sessions.
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-129">
                <div className="w-12 h-12 rounded-full bg-navy-50 flex items-center justify-center text-brand-coral mr-4 flex-shrink-0" data-id="element-130">
                  <BookOpenIcon className="w-6 h-6" data-id="element-131" />
                </div>
                <div data-id="element-132">
                  <h4 className="font-bold text-navy-900 text-lg" data-id="element-133">
                    Schools & Workshops
                  </h4>
                  <p className="text-navy-600" data-id="element-134">
                    Bring Bright Star to your school.
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-135">
                <div className="w-12 h-12 rounded-full bg-navy-50 flex items-center justify-center text-brand-green mr-4 flex-shrink-0" data-id="element-136">
                  <MessageSquareIcon className="w-6 h-6" data-id="element-137" />
                </div>
                <div data-id="element-138">
                  <h4 className="font-bold text-navy-900 text-lg" data-id="element-139">
                    Partnerships
                  </h4>
                  <p className="text-navy-600" data-id="element-140">
                    Sponsorship and collaboration opportunities.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side: Form */}
          <div data-id="element-141">
            <ContactForm data-id="element-142" />
          </div>
        </div>
      </div>
    </section>;
}